export default "__VITE_ASSET__BCl5I7Bd__"